module.exports = __webpack_public_path__ + "static/pamper2-002a0a267d76902864d7da371264a8da.jpg";